// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-outer-container {
  display: flex;
  flex-direction: column;
  gap: var(--dialog-element-gap);
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.settings-container-fixed,
.settings-container {
  display: flex;
  flex-direction: column;
  gap: var(--dialog-element-gap);
  width: 100%;
  box-sizing: border-box;
  padding: var(--input-element-gap) var(--dialog-padding);
}

.settings-container {
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;
  container-type: inline-size;
}

.settings-row {
  display: flex;
  flex-direction: row;
  gap: var(--input-element-gap);
  width: 100%;

  > .preference-checkbox {
    flex-grow: 1;
  }
}

.settings-empty-row {
  height: var(--dialog-element-gap);
}

.settings-centered-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.settings-responsive-row {
  display: flex;
  flex-direction: row;
  gap: var(--input-element-gap);
  width: 100%;
}

.settings-responsive-row-spacer {
  width: var(--input-element-height);
}

@container (max-width: 620px) {
  .settings-responsive-row {
    flex-direction: column;
  }
  .settings-responsive-row-spacer {
    width: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/style/common-classes/settings-classes.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;EACtB,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;;EAEX;IACE,YAAY;EACd;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,QAAQ;EACV;AACF","sourcesContent":[".settings-outer-container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--dialog-element-gap);\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n}\n\n.settings-container-fixed,\n.settings-container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--dialog-element-gap);\n  width: 100%;\n  box-sizing: border-box;\n  padding: var(--input-element-gap) var(--dialog-padding);\n}\n\n.settings-container {\n  overflow-x: hidden;\n  overflow-y: auto;\n  height: 100%;\n  container-type: inline-size;\n}\n\n.settings-row {\n  display: flex;\n  flex-direction: row;\n  gap: var(--input-element-gap);\n  width: 100%;\n\n  > .preference-checkbox {\n    flex-grow: 1;\n  }\n}\n\n.settings-empty-row {\n  height: var(--dialog-element-gap);\n}\n\n.settings-centered-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.settings-responsive-row {\n  display: flex;\n  flex-direction: row;\n  gap: var(--input-element-gap);\n  width: 100%;\n}\n\n.settings-responsive-row-spacer {\n  width: var(--input-element-height);\n}\n\n@container (max-width: 620px) {\n  .settings-responsive-row {\n    flex-direction: column;\n  }\n  .settings-responsive-row-spacer {\n    width: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
